import React, { useCallback, memo } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { Card, Space } from '@redlink/components/atoms';
import { DataGridHeader } from './dataGridHeader';
import { DataGridRow } from './dataGridRow';

export const DataGrid = memo(
  ({ children, data, sortBy, sortByDirection, onSort }) => {
    const { styles } = useStyle();

    const renderRows = useCallback(
      () =>
        data.map((item, index) => (
          <DataGridRow {...{ index }} dataItem={item}>
            {children}
          </DataGridRow>
        )),
      [data, children]
    );

    return (
      <Card style={styles.container}>
        <DataGridHeader {...{ sortBy, sortByDirection, onSort }}>
          {children}
        </DataGridHeader>
        <Space size={8} />
        {renderRows()}
      </Card>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    padding: 0,
  },
}));
